import {
  Avatar,
  Box,
  Button,
  Divider,
  Fade,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { Fragment, useState } from "react";
import TabPills from "./TabPills";
import { headerLinks, menuNavLinks } from "./LinkData";
import ListYourEquipmentBtn from "./ListYourEquipementBtn";
import { ROUTES } from "constants/routes";

const MenuOptions = (props: any) => {
  const { displayName, pic, email, isLoggedIn, onClose, setShowDialog } = props;
  const [tabIndex, setTabIndex] = useState<number>(1);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Fade in={true} style={{ transitionDuration: "500ms" }}>
      <List sx={{ p: 0 }}>
        {isLoggedIn && (
          <Fragment>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate(ROUTES.PROFILE);
                  onClose();
                }}
              >
                <ListItemIcon sx={{ mr: 1 }}>
                  <Avatar
                    sx={{ width: 56, height: 56 }}
                    alt={displayName}
                    src={pic}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={displayName}
                  secondary={email}
                  primaryTypographyProps={{
                    color: "common.black",
                    textTransform: "capitalize",
                    fontWeight: 600,
                    fontSize: "18px",
                    lineHeight: "48px",
                    marginTop: "-12px",
                  }}
                  secondaryTypographyProps={{
                    fontSize: "14px",
                    color: "#323232",
                    fontWeight: 400,
                    fontFamily: "Inter",
                    marginTop: "-12px",
                  }}
                />
              </ListItemButton>
            </ListItem>
            <Divider />
          </Fragment>
        )}

        {isLoggedIn && (
          <Fragment>
            <TabPills tabIndex={tabIndex} setTabIndex={setTabIndex} />

            {menuNavLinks[tabIndex]?.map(
              ({ label, path, Icon, color = "#323232" }: any) => (
                <ListItem key={label} sx={{ py: "4px" }}>
                  <ListItemButton
                    onClick={() => {
                      if (label == "Logout") return setShowDialog(true);
                      navigate(path);
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={Icon}
                        alt=""
                        style={{ width: "24px", height: "24px" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ ml: -1.5 }}
                      primaryTypographyProps={{
                        color: color,
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "20px",
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              )
            )}
          </Fragment>
        )}

        {isMobile && (
          <Fragment>
            {isLoggedIn && <br />}
            {isLoggedIn && <Divider />}
            <br />
            {headerLinks?.map(
              ({
                label,
                path,
                Icon,
                color = "#323232",
                action = null,
              }: any) => (
                <ListItem key={label} sx={{ py: "4px" }}>
                  <ListItemButton
                    onClick={() => {
                      !action && navigate(path);
                      action && action();
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={Icon}
                        alt=""
                        style={{ width: "24px", height: "24px" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ ml: -1.5 }}
                      primaryTypographyProps={{
                        color: color,
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "20px",
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              )
            )}

            {!isLoggedIn && (
              <Fragment>
                <Divider />
                <br />
                <ListItem key={"Login"} sx={{ py: "4px" }}>
                  <ListItemButton
                    onClick={() => {
                      navigate(ROUTES.SIGNIN);
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={require("assets/img/png/Login.png")}
                        alt=""
                        style={{ width: "24px", height: "24px" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ ml: -1.5 }}
                      primaryTypographyProps={{
                        color: "#323232",
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "20px",
                      }}
                      primary={"Login"}
                    />
                  </ListItemButton>
                </ListItem>

                <ListItem key={"Signup"} sx={{ py: "4px" }}>
                  <ListItemButton
                    onClick={() => {
                      navigate(ROUTES.SIGNUP);
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={require("assets/img/png/Signup.png")}
                        alt=""
                        style={{ width: "24px", height: "24px" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ ml: -1.5 }}
                      primaryTypographyProps={{
                        color: "#323232",
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "20px",
                      }}
                      primary={"Signup"}
                    />
                  </ListItemButton>
                </ListItem>
              </Fragment>
            )}
            <Box
              sx={{
                px: 4,
                py: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ListYourEquipmentBtn
                isLoggedIn={isLoggedIn}
                zeroMargin={true}
                fullWidth
                sx={{ p: 1.5, mb: 6 }}
                handleClick={onClose}
              />
            </Box>
            <br />
          </Fragment>
        )}
      </List>
    </Fade>
  );
};

export default MenuOptions;
